import { formatTime } from "../../utils";
import axios from "../api";
/**
 * One backend set as the app keeps it. Shared with every route that embeds a
 * set in the `GET /sbc-sets` shape (Home's drops), so they read the same.
 */
export const toSbcSet = (sbcSet) => {
    const reward = sbcSet.rewards?.[0];
    let timeRemaining = "";
    if (sbcSet.endTime) {
        const endDay = new Date(sbcSet.endTime * 1000);
        const today = new Date();
        const timeDiff = endDay.getTime() - today.getTime();
        timeRemaining = formatTime(timeDiff);
    }
    return {
        ...sbcSet,
        timeRemaining,
        reward,
        message: sbcSet.message,
        repeats: sbcSet.repeats || 0,
        unsolvable: sbcSet.unsolvable,
    };
};
export async function getSbcSets() {
    // The backend rejects the request without page/limit but ignores their
    // values and always returns every set
    const res = await axios.get("/sbc-sets?page=1&limit=10");
    return res.data.map(toSbcSet);
}
//# sourceMappingURL=getSbcSets.js.map